import React from 'react'
import { Downgraded } from '@hookstate/core'
import { useLang } from '~/hooks/useLang'
import { Grid, Typography } from '@mui/material'
import ColumnChartHorizontal from '~/components/ColumnChartMui/HorizontalChart'
import useManagementQualifiersObjectState from '~/features/Management/stores/ManagementQualifiersObjectState'
import { calculateBarChartTotal } from '~/utils/format'

interface ChartsObjectProps {
  readonly expandFilterSearch: boolean
}

export default function ChartsObject({
  expandFilterSearch,
}: ChartsObjectProps) {
  const { translate } = useLang()
  const { occurrencesAssociatedObject } = useManagementQualifiersObjectState()


  return (
    <Grid
      container
      xs={12}
      sx={{
        display: 'flex',
        paddingX: 3,
        paddingTop: 3,
        justifyContent: 'space-between',
      }}
    >
      <Grid item xs={12} hidden={!expandFilterSearch} paddingBottom={1}>
        <Typography sx={{ fontWeight: 'bold', fontSize: 16 }}>
          {translate('Registered object')}
        </Typography>
      </Grid>

      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedObject()
            .occurrencesAssociatedObjectByType.attach(Downgraded)
            .get()}
          title={'ObjectType:name'}
          subtitle={`Total de objetos: ${calculateBarChartTotal(
            occurrencesAssociatedObject()
              .occurrencesAssociatedObjectByType.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'typeMinus'}
          colorBar="primary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedObject()
            .occurrencesAssociatedObjectByOccurrenceType.attach(Downgraded)
            .get()}
          title={`${translate('ObjectModel:name')}`}
          subtitle={`Total de objetos: ${calculateBarChartTotal(
            occurrencesAssociatedObject()
              .occurrencesAssociatedObjectByOccurrenceType.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'typeMinus'}
          colorBar="secondary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedObject()
            .occurrencesAssociatedObjectByCircunstance.attach(Downgraded)
            .get()}
          title={`${translate('Circunstance of the object')}`}
          subtitle={`Total de objetos: ${calculateBarChartTotal(
            occurrencesAssociatedObject()
              .occurrencesAssociatedObjectByCircunstance.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'situations'}
          colorBar="tertiary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedObject()
            .occurrencesAssociatedObjectByDestination.attach(Downgraded)
            .get()}
          title={`${translate('Final destination of the object')}`}
          subtitle={`Total de objetos: ${calculateBarChartTotal(
            occurrencesAssociatedObject()
              .occurrencesAssociatedObjectByDestination.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'finals destinations'}
          colorBar="primary"
        />
      </Grid>
    </Grid>
  )
}
